import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches appointments for a specific member in reverse-chronological order. Only fires when enabled. */
export function useListMemberAppointments(memberId: string, enabled = true) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['appointments', { memberId, sort: 'desc' }],
    enabled,
    queryFn: async () => {
      const response = await api.get('/appointments', { query: { memberId, sort: 'desc' } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.appointments
    },
  })
}
